/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { ItemSelector } from './item-selector';

function ControlBoxSelector(props: any) {
  return <ItemSelector {...props} />;
}

export default connect(
  (state: any) => ({ items: state.controlBoxes.myControlBoxes }),
  () => ({})
)(ControlBoxSelector);
